const LocalStorageService = {
  setItem(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.error(`Error saving to localStorage: ${error}`);
    }
  },
  getItem(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      console.error(`Error getting data from localStorage: ${error}`);
      return null;
    }
  },
  removeItem(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing data from localStorage: ${error}`);
    }
  },
  clear(preserveKeys: readonly string[] = []): void {
    try {
      if (preserveKeys.length === 0) {
        window.localStorage.clear();
        return;
      }

      const keysToPreserve = new Set(preserveKeys);
      const keysToRemove: string[] = [];

      for (let index = 0; index < window.localStorage.length; index++) {
        const key = window.localStorage.key(index);
        if (key !== null && !keysToPreserve.has(key)) keysToRemove.push(key);
      }

      keysToRemove.forEach((key) => window.localStorage.removeItem(key));
    } catch (error) {
      console.error(`Error clearing localStorage: ${error}`);
    }
  }
};

export default LocalStorageService;
